import React, { useState } from 'react';
import axios from 'axios';
import './index.css'
import './App.css';

function App() {
  const [query, setQuery] = useState('');
  const [images, setImages] = useState([]);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!query) {
      setError('Enter Search Query First.');
      return;
    }
    const apiUrl = `https://api.unsplash.com/search/photos?query=${query}&client_id=rvRXw5wRR0jnREM43h7eUppe5UUyvnFFhQpnF63m34E`;
    try {
      const response = await axios.get(apiUrl);
      const images = response.data.results.map(result => result.urls.regular);
      setImages(images);
      setError(null);
    } catch (error) {
      console.error('Error fetching images:', error);
      setError('Error fetching images. Please try again later.');
      setImages([]);
    }
  };

  return (
    <>
      <div className="main">
        <h1>FINDMON <span>📸</span></h1>
        <p>Discover <span>Stunning Images</span> with FINDMON<span>
        </span>
        </p>
        <form onSubmit={handleSubmit} autoComplete="off">
          <input type="text" id="query" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search for Images, Illustrations, Portraits etc." />
          <button type="submit">Search</button>
        </form>
        <div className='errorContainer'>
          {error && <p className='errormsg'>{error}</p>}
        </div>
      </div>
      {images.length > 0 && (
        <div className="outcome">
          <hr />
          <h2>Results for {query}</h2>
          <div className="imgContainer">
            {images.map((image, index) => (
              <div className="imgs" key={index}>

                <img src={image} alt="Unsplash Photo" />

                <button onClick={() => downloadImage(image, `photo_${index + 1}`)}> ⇲ </button>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className='footer'>
        <p>Built<span>@Yash🐞</span></p>
      </div>
    </>
  );
}

function downloadImage(url, filename) {
  var xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  xhr.onload = function () {
    var a = document.createElement('a');
    a.href = window.URL.createObjectURL(xhr.response);
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  xhr.open('GET', url);
  xhr.send();
}

export default App;
